/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MissingInfoFollowUpRequestedItem
 */
export interface MissingInfoFollowUpRequestedItem {
    /**
     * 
     */
    description: string;
}

/**
 * Check if a given object implements the MissingInfoFollowUpRequestedItem interface.
 */
export function instanceOfMissingInfoFollowUpRequestedItem(value: object): value is MissingInfoFollowUpRequestedItem {
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function MissingInfoFollowUpRequestedItemFromJSON(json: any): MissingInfoFollowUpRequestedItem {
    return MissingInfoFollowUpRequestedItemFromJSONTyped(json, false);
}

export function MissingInfoFollowUpRequestedItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MissingInfoFollowUpRequestedItem {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'],
    };
}

export function MissingInfoFollowUpRequestedItemToJSON(json: any): MissingInfoFollowUpRequestedItem {
    return MissingInfoFollowUpRequestedItemToJSONTyped(json, false);
}

export function MissingInfoFollowUpRequestedItemToJSONTyped(value?: MissingInfoFollowUpRequestedItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
    };
}

